
<div class="container p-4">

    <div *ngIf="status != 'loggedin'" class="mt-1 mb-4">
    <h3 class="text-left" i18n="@@signup">Sign Up</h3>
    <h6 class="text-left" i18n="@@signupdesc"> Please fill all required fields , to create new account</h6>
    <div class="mt-4 card" style="min-height: 400px">
<app-registration></app-registration>
    </div>
    </div>
    <div *ngIf="status == 'loggedin'" class="mt-4 mb-4" style="min-height: 400px">
        <p i18n="@@loggedin">You logged in successfully </p>
    </div>
</div>
